var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid lg:grid-cols-2 gap-x-[20px] lg:gap-x-[50px]" },
    [
      _c("h3", {
        staticClass:
          "text-white text-[34px] leading-[35px] md:text-[50px] md:leading-[50px] mb-[20px] lg:col-span-2",
        domProps: { innerHTML: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mb-[32px]" }, [
        _vm.subtitle
          ? _c("h3", {
              staticClass:
                "text-orange text-[18px] leading-[19px] md:text-[30px] md:leading-[35px] font-bold mb-[16px]",
              domProps: { innerHTML: _vm._s(_vm.subtitle) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.description
          ? _c("div", {
              staticClass:
                "text-white text-[12px] leading-[16px] md:text-[16px] md:leading-[22px] flex flex-col gap-[16px]",
              domProps: { innerHTML: _vm._s(_vm.description) }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("form-base", {
        ref: "form",
        staticClass:
          "scan-form grid grid-cols-1 lg:grid-cols-2 gap-[19px] lg:gap-y-[19px] lg:gap-x-[19px] h-full lg:h-auto",
        on: { submit: _vm.submit },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var loading = ref.loading
              var success = ref.success
              return [
                _c("form-input", {
                  staticClass: "dark",
                  attrs: {
                    name: "first_name",
                    placeholder: "Voornaam",
                    rules: "required"
                  },
                  model: {
                    value: _vm.payload.first_name,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "first_name", $$v)
                    },
                    expression: "payload.first_name"
                  }
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "dark",
                  attrs: {
                    name: "last_name",
                    placeholder: "Achternaam",
                    rules: "required"
                  },
                  model: {
                    value: _vm.payload.last_name,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "last_name", $$v)
                    },
                    expression: "payload.last_name"
                  }
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "lg:col-span-2 dark",
                  attrs: {
                    name: "company_email",
                    placeholder: "E-mailadres",
                    type: "email",
                    rules: "required|email"
                  },
                  model: {
                    value: _vm.payload.company_email,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "company_email", $$v)
                    },
                    expression: "payload.company_email"
                  }
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "lg:col-span-2 dark",
                  attrs: {
                    name: "company_name",
                    placeholder: "Bedrijfsnaam",
                    rules: "required"
                  },
                  model: {
                    value: _vm.payload.company_name,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "company_name", $$v)
                    },
                    expression: "payload.company_name"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "lg:col-span-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.termsAccepted,
                        expression: "termsAccepted"
                      }
                    ],
                    attrs: { type: "checkbox", id: _vm._uid, required: "true" },
                    domProps: {
                      checked: Array.isArray(_vm.termsAccepted)
                        ? _vm._i(_vm.termsAccepted, null) > -1
                        : _vm.termsAccepted
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.termsAccepted,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.termsAccepted = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.termsAccepted = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.termsAccepted = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "text-white", attrs: { for: _vm._uid } },
                    [
                      _vm._v("Ik heb de "),
                      _c(
                        "a",
                        {
                          staticClass: "underline",
                          attrs: { href: "/privacybeleid" }
                        },
                        [_vm._v("gebruiksvoorwaarden")]
                      ),
                      _vm._v(" gelezen en ga akkoord.")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("form-error", {
                  staticClass: "lg:col-span-2 ",
                  attrs: { "error-response": _vm.errorResponse }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "lg:col-span-2 flex items-center  gap-32 mt-24"
                  },
                  [
                    _c(
                      "form-submit",
                      {
                        staticClass: "!bg-orange !text-white",
                        attrs: {
                          disabled: invalid,
                          loading: loading,
                          success: success
                        }
                      },
                      [_vm._v("verstuur")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-bold text-white" }, [
                      _vm._v(_vm._s(_vm.success_message))
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }